/**
 * Identifies the message transaction type.
 * tag: 3064
 * @readonly
 * @enum {number} (int)
 */
export enum TestSuiteRequestTransType {
  /** New */
  New = 0,
  /** Cancel */
  Cancel = 1,
}
